import React from 'react';
import { Offcanvas, Button } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import CustomDatePicker from '../../../../../../components/common/CustomDatePicker/CustomDatePicker';
import CheckboxMultiSelect from '../../../../../../components/common/CheckboxMultiSelect/CheckboxMultiSelect';
import './OffCanvas.scss';

interface FilterOption {
  value: any;
  label: string;
}

interface OffCanvasProps {
  show: boolean;
  setShow: (show: boolean) => void;
  
  // Date filters
  startDate: string;
  setStartDate: (date: string) => void;
  endDate: string;
  setEndDate: (date: string) => void;
  
  // Dropdown filters
  userOptions: FilterOption[];
  selectedUsers: FilterOption[];
  setSelectedUsers: (users: FilterOption[]) => void;
  
  priceTypeOptions: FilterOption[];
  selectedPriceTypes: FilterOption[];
  setSelectedPriceTypes: (types: FilterOption[]) => void;
  
  changeTypeOptions: FilterOption[];
  selectedChangeTypes: FilterOption[];
  setSelectedChangeTypes: (types: FilterOption[]) => void;
}

const OffCanvas: React.FC<OffCanvasProps> = ({
  show,
  setShow,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  userOptions,
  selectedUsers,
  setSelectedUsers,
  priceTypeOptions,
  selectedPriceTypes,
  setSelectedPriceTypes,
  changeTypeOptions,
  selectedChangeTypes,
  setSelectedChangeTypes
}) => {
  const handleClose = () => setShow(false);

  const handleClearFilters = () => {
    setSelectedUsers([]);
    setSelectedPriceTypes([]);
    setSelectedChangeTypes([]);
  };

  return (
    <Offcanvas 
      show={show} 
      onHide={handleClose} 
      placement="end"
      className="price-changes-offcanvas"
    >
      <Offcanvas.Header>
        <Offcanvas.Title>Filtros</Offcanvas.Title>
        <Button variant="none" onClick={handleClose} className="close-btn">
          <FaTimes />
        </Button>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="filter-section">
          <h6 className="section-title">Rango de Fechas</h6>
          <div className="date-inputs">
            <div className="date-input-group">
              <label>Desde</label>
              <CustomDatePicker
                value={startDate}
                onChange={setStartDate}
                placeholder="Desde"
              />
            </div>
            <div className="date-input-group">
              <label>Hasta</label>
              <CustomDatePicker
                value={endDate}
                onChange={setEndDate}
                placeholder="Hasta"
              />
            </div>
          </div>
        </div>

        <div className="filter-section">
          <h6 className="section-title">Usuario</h6>
          <CheckboxMultiSelect
            options={userOptions}
            value={selectedUsers}
            onChange={setSelectedUsers}
            placeholder="Todos los usuarios"
          />
        </div>

        <div className="filter-section">
          <h6 className="section-title">Tipo de Precio</h6>
          <CheckboxMultiSelect
            options={priceTypeOptions}
            value={selectedPriceTypes}
            onChange={setSelectedPriceTypes}
            placeholder="Todos los tipos"
          />
        </div>

        <div className="filter-section">
          <h6 className="section-title">Tipo de Cambio</h6>
          <CheckboxMultiSelect
            options={changeTypeOptions}
            value={selectedChangeTypes}
            onChange={setSelectedChangeTypes}
            placeholder="Todos los cambios"
          />
        </div>

        <div className="filter-actions">
          <Button 
            variant="outline-secondary" 
            onClick={handleClearFilters}
            className="clear-btn"
          >
            Limpiar Filtros
          </Button>
          <Button 
            variant="primary" 
            onClick={handleClose}
            className="apply-btn"
          >
            Aplicar
          </Button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default OffCanvas;
